import { OutputData } from "@editorjs/editorjs";
import { ImageSourceSetData } from "../../../../common/classes/ImageSourceSet";
import {
  FieldState,
  valFileTotalSize,
} from "../../../../utils/ValidationFunctions";
import {
  fieldStateToUpdateArgs,
  validFieldState,
} from "../FieldStateFunctions";
import { SonicTermData } from "../../../../common/classes/SonicTerm";

// 画像合計サイズチェック
export const valTopicImages = (
  mainImage?: File | ImageSourceSetData,
  article?: OutputData
) => {
  const uploadImgs: Array<File> = [];
  if (mainImage instanceof File) {
    uploadImgs.push(mainImage);
  }

  article?.blocks.forEach((block) => {
    if (block.type === "image" && block.data instanceof File) {
      uploadImgs.push(block.data);
    }
  });

  return valFileTotalSize(uploadImgs);
};

// 必須項目チェック
export const valTopicRequiredItem = (
  pageType: "create" | "edit",
  fieldState?: FieldState,
  article?: OutputData,
  mainImage?: File | ImageSourceSetData
) => {
  // Check fieldState
  if (
    !validFieldState(
      pageType,
      ["sonic_name", "sonic_topic_type", "sonic_start_date"],
      fieldState
    )
  ) {
    return false;
  }

  // Check article
  if (!article || article.blocks.length === 0) {
    return false;
  }

  // Check main image
  if (!mainImage) {
    return false;
  }

  return true;
};

// 送信データ作成
export const genTopicUpdateArgs = (
  fieldState?: FieldState,
  article?: OutputData,
  mainImage?: File | ImageSourceSetData,
  games?: Array<SonicTermData>
) => {
  const updateArgs: { [key: string]: string | File } = {};
  fieldStateToUpdateArgs(updateArgs, fieldState);

  if (mainImage instanceof File) {
    updateArgs["sonic_img"] = mainImage;
  }

  const uploadImgs: Array<File | string> = [];
  const imgsMeta: Array<string> = [];

  article?.blocks.forEach((block) => {
    if (block.type === "image") {
      if (block.data instanceof File) {
        uploadImgs.push(block.data);
      }

      if (typeof block.data === "object" && block.data.id) {
        uploadImgs.push(block.data.id);
      }

      // 画像は別で送信するためデータを削減
      block.data = {};
    }
  });

  uploadImgs.forEach((img, i) => {
    if (img instanceof File) {
      updateArgs[`sonic_content_imgs${i}`] = img;
      imgsMeta.push("new");
    } else {
      updateArgs[`sonic_content_imgs${i}`] = "";
      imgsMeta.push(img);
    }
  });
  updateArgs["sonic_imgs_meta"] = JSON.stringify(imgsMeta);

  if (games && games.length > 0) {
    const gameIds: Array<string> = [];
    games.forEach((game) => gameIds.push(game.id));
    updateArgs["sonic_game"] = JSON.stringify(gameIds);
  }

  updateArgs["sonic_content"] = JSON.stringify(article);

  return updateArgs;
};
